module.exports = function (val1, val2, options) {
  return val1 === val2
    ? options.inverse(this)
    : options.fn(this);
};
